module.exports = __webpack_public_path__ + "static/media/how_pc.9255ce3c.jpeg";